import { css, SerializedStyles } from '@emotion/react';

interface Spacing {
    topGutter?: number|null
    bottomGutter?: number|null
}

const paddingDefault = (spacing?: Spacing|null, asMargin = false): SerializedStyles|null => {
    const { topGutter, bottomGutter } = spacing || {
        topGutter: 100,
        bottomGutter: 100,
    };

    if ([typeof topGutter, typeof bottomGutter].includes('undefined')) {
        return null;
    }

    const baseMobile = 2;
    const baseDesktop = 4;

    const top = typeof topGutter === 'number' ? topGutter : 100;
    const bottom = typeof bottomGutter === 'number' ? bottomGutter : 100;

    const mobileTop = (baseMobile * top) / 100;
    const desktopTop = (baseDesktop * top) / 100;
    const mobileBottom = (baseMobile * bottom) / 100;
    const desktopBottom = (baseDesktop * bottom) / 100;

    const property = asMargin ? 'margin' : 'padding';

    return css({
        [`${property}Top`]: `${mobileTop}rem`,
        [`${property}Bottom`]: `${mobileBottom}rem`,
        '@media (min-width: 1024px)': {
            [`${property}Top`]: `${desktopTop}rem`,
            [`${property}Bottom`]: `${desktopBottom}rem`,
        },
    });
};

export default paddingDefault;
